import './SocialBar.css'

import React from 'react'

import buttons from './buttons'

function SocialBar({ providers, url, message, hashtag, beforeShare }) {
  return (
    <div className="SocialBar-container">
      {providers.map(provider => {
        const Button = buttons[provider]
        if (!Button) {
          console.warn('Unknown social provider', provider)
          return null
        }
        return (
          <Button
            key={provider}
            url={url}
            message={message}
            hashtag={hashtag}
            beforeOnClick={e => beforeShare && beforeShare(provider, e)}
          />
        )
      })}
    </div>
  )
}

export default SocialBar



// WEBPACK FOOTER //
// ./src/addons/social/SocialBar.js